/* unplugin-vue-components disabled */import script from "./message-video.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-video.vue?vue&type=script&lang=ts&setup=true"

import "./message-video.vue?vue&type=style&index=0&id=30b66f58&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b66f58"]])

export default __exports__